import { ApartmentOutlined, SolutionOutlined } from "@ant-design/icons";
import { lazy } from "react";
import { permissionCodeConstant } from "../utils/permissionCodeConstant";

export const reportStaticPath = {
    report: '/report',
    spareMovementReport: '/spare-movement-report',
    sparePartsUsageSummaryReport: '/spare-usage-summary-report',
    assetMaintenanceReport: '/asset-report',
    assetPerformance: '/asset-performance',
    assetDepreciation: '/asset-depreciation-report',
    processingStatusReportBreakdown: '/processing-status-report-breakdown',
    processingStatusReportSchedulePreventive: '/processing-status-report-schedule-preventive',
    reportAssetMaintenanceRequest: '/report-assetMaintenance-request',
    reportEngineerPerformanceInBreakdown: '/report-engineer-performance-in-breakdown',
    reportEngineerPerformanceInSchedulePreventive: '/report-engineer-performance-in-schedulePreventive',
    reportWorkByPerson: '/report-work-by-person',
};

export const routeReport = [
    {
        key: reportStaticPath.report,
        path: reportStaticPath.report,
        label: "Báo cáo",
        exact: true,
        icon: <ApartmentOutlined />,
        component: lazy(() => import("../pages/report")),
        un_check_permission: true,
    },
    {
        key: reportStaticPath.spareMovementReport,
        path: reportStaticPath.spareMovementReport,
        label: "Báo cáo sử dụng phụ tùng",
        icon: <ApartmentOutlined />,
        component: lazy(() => import("../pages/report/sparePart/SparePartsUsage")),
        permisisonCode: permissionCodeConstant.report_spare_movement_report,
    },
    {
        key: reportStaticPath.sparePartsUsageSummaryReport,
        path: reportStaticPath.sparePartsUsageSummaryReport,
        label: "Báo cáo tổng hợp sử dụng phụ tùng",
        icon: <ApartmentOutlined />,
        component: lazy(() => import("../pages/report/sparePart/SparePartsUsageSummaryReport")),
        un_check_permission: true,
    },
    {
        key: reportStaticPath.assetMaintenanceReport,
        path: reportStaticPath.assetMaintenanceReport,
        label: "Báo cáo tài sản",
        icon: <ApartmentOutlined />,
        component: lazy(() => import("../pages/report/assetMaintenance/AssetMaintenanceReport")), un_check_permission: true,
    },
    {
        key: reportStaticPath.assetPerformance,
        path: reportStaticPath.assetPerformance,
        label: "Báo cáo hiệu suất tài sản",
        icon: <ApartmentOutlined />,
        component: lazy(() => import("../pages/report/assetMaintenance/AssetPerformance")), un_check_permission: true,
    },
    {
        key: reportStaticPath.assetDepreciation,
        path: reportStaticPath.assetDepreciation,
        label: "Báo cáo khấu hao tài sản",
        icon: <ApartmentOutlined />,
        component: lazy(() => import("../pages/report/assetMaintenance/AssetDepreciation")), un_check_permission: true,
    },
    {
        path: reportStaticPath.processingStatusReportBreakdown,
        exact: true,
        show_menu: false,
        icon: <SolutionOutlined />,
        key: reportStaticPath.processingStatusReportBreakdown,
        label: "Báo cáo tình hình xử lý sự cố",
        component: lazy(() => import("../pages/report/reportBreakdown/ProcessingStatusReportBreakdown")), un_check_permission: true,
    },
    {
        path: reportStaticPath.processingStatusReportSchedulePreventive,
        exact: true,
        show_menu: false,
        icon: <SolutionOutlined />,
        key: reportStaticPath.processingStatusReportSchedulePreventive,
        label: "Báo cáo tình hình xử lý công việc",
        component: lazy(() => import("../pages/report/reportSchedulePreventive/ProcessingStatusReportSchedulePreventive")), un_check_permission: true,
    },
    {
        path: reportStaticPath.reportAssetMaintenanceRequest,
        exact: true,
        show_menu: false,
        icon: <SolutionOutlined />,
        key: reportStaticPath.reportAssetMaintenanceRequest,
        label: "Yêu cầu bảo trì",
        component: lazy(() => import("../pages/report/reportAssetMaintenanceRequest/ReportAssetMaintenanceRequest")), un_check_permission: true,
    },
    {
        path: reportStaticPath.reportEngineerPerformanceInBreakdown,
        exact: true,
        show_menu: false,
        icon: <SolutionOutlined />,
        key: reportStaticPath.reportEngineerPerformanceInBreakdown,
        label: "Báo cáo hiệu suất kỹ sư trong sự cố",
        component: lazy(() => import("../pages/report/reportBreakdown/ReportEngineerPerformanceInBreakdown")), un_check_permission: true,
    },
    {
        path: reportStaticPath.reportEngineerPerformanceInSchedulePreventive,
        exact: true,
        show_menu: false,
        icon: <SolutionOutlined />,
        key: reportStaticPath.reportEngineerPerformanceInSchedulePreventive,
        label: "Báo cáo hiệu suất kỹ sư trong công việc",
        component: lazy(() => import("../pages/report/reportSchedulePreventive/ReportEngineerPerformanceInSchedulePreventive")), un_check_permission: true,
    },
    {
        path: reportStaticPath.reportWorkByPerson,
        exact: true,
        show_menu: false,
        icon: <SolutionOutlined />,
        key: reportStaticPath.reportWorkByPerson,
        label: "Báo cáo công việc theo người thực hiện",
        component: lazy(() => import("../pages/report/general/reportWorkByPerson")),
        un_check_permission: true,
    },
];
